/* STEFANO - spedizione stimata (product, box, oyma, mystery-box) */
(function () {
  var CUTOFF_HOUR = 14;
  var DAY_NAMES = ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'];
  var TIMEZONE = 'Europe/Rome';

  var formatter = new Intl.DateTimeFormat('en-GB', {
    timeZone: TIMEZONE,
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hourCycle: 'h23',
  });

  /* Ora attuale a Roma, come data "UTC" per poter fare i calcoli senza fuso del browser */
  function romeNow() {
    var p = {};
    formatter.formatToParts(new Date()).forEach(function (part) {
      p[part.type] = Number(part.value);
    });
    return new Date(Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second));
  }

  function isWeekend(date) {
    var day = date.getUTCDay();
    return day === 0 || day === 6;
  }

  function addBusinessDays(date, days) {
    var result = new Date(date);
    while (days > 0) {
      result.setUTCDate(result.getUTCDate() + 1);
      if (!isWeekend(result)) days--;
    }
    return result;
  }

  function formatDate(date) {
    var d = String(date.getUTCDate()).padStart(2, '0');
    var m = String(date.getUTCMonth() + 1).padStart(2, '0');
    return DAY_NAMES[date.getUTCDay()] + ' ' + d + '/' + m;
  }

  function secondsToCutoff(now) {
    var cutoff = new Date(now);
    cutoff.setUTCHours(CUTOFF_HOUR, 0, 0, 0);
    return Math.floor((cutoff - now) / 1000);
  }

  function init() {
    var block = document.getElementById('shipping-estimate-block');
    var dateEl = document.getElementById('shipping-date');
    var orderEl = document.getElementById('order-before');
    if (!block || !dateEl || !orderEl) return;

    if ((document.documentElement.lang || 'it').slice(0, 2).toLowerCase() !== 'it') {
      block.style.display = 'none';
      return;
    }

    var now = romeNow();
    var canShipToday = !isWeekend(now) && secondsToCutoff(now) > 0;
    var minDays = canShipToday ? 1 : 2;

    dateEl.innerHTML =
      '🚚 Data stimata di consegna: <strong>' +
      formatDate(addBusinessDays(now, minDays)) +
      ' - ' +
      formatDate(addBusinessDays(now, minDays + 1)) +
      '</strong>';

    if (!canShipToday) {
      orderEl.style.display = 'none';
      return;
    }

    function tick() {
      var left = secondsToCutoff(romeNow());

      if (left <= 0) {
        orderEl.style.display = 'none';
        clearInterval(timer);
        return;
      }

      var parts = [];
      var hours = Math.floor(left / 3600);
      if (hours > 0) parts.push(hours + 'h');
      parts.push(Math.floor((left % 3600) / 60) + 'm');
      parts.push((left % 60) + 's');

      orderEl.innerHTML = '🚀 Ordina entro <strong>' + parts.join(', ') + '</strong> e lo spediamo oggi!';
      orderEl.style.display = 'block';
    }

    var timer = setInterval(tick, 1000);
    tick();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
